import { Drawer, Table } from '@/components/ats';
import { Button, Flex } from '@chakra-ui/react';
import { useScheduleTableConfig } from './useScheduleTableConfig';
import { ReportsEmpty } from '@/assets/icons/reports';
import { EmptyResults } from '@/components/ats';

export const ScheduleReportsEmailTable = ({
  isLoading = undefined,
  modalActions,
  data,
  setSelectedReport = undefined,
  setCurrentView,
}) => {
  const { columnConfig, rowConfig } = useScheduleTableConfig({
    setCurrentView,
    setSelectedReport,
  });
  const renderTable = () => {
    return (
      <Flex flex="1" h="100%" p="12px 24px" overflow="hidden">
        {data?.length ? (
          <Table
            data={data}
            columns={columnConfig}
            rowActionMenuItems={rowConfig}
          />
        ) : (
          <Flex justify="center" align="center" h="100%" w="100%">
            <EmptyResults
              icon={ReportsEmpty}
              wrapperProps={{ h: '100%' }}
              showText={false}
              iconProps={{ h: '120px', w: '150px', mb: '0px' }}
              placeholderProps={{
                size: 'xs-medium',
                color: 'secondary-700',
              }}
              placeholder="LOOKS EMPTY IN HERE"
              subText="No email scheduled yet"
              subTextProps={{
                size: 'lg-semi-bold',
                color: 'secondary-900',
              }}
            />
          </Flex>
        )}
      </Flex>
    );
  };

  return (
    <>
      {modalActions?.isOpen && (
        <Drawer
          drawerActions={modalActions}
          drawerContentProps={{
            minW: '969px',
          }}
          headerText="Scheduled emails"
          headerDescription="View all your scheduled emails and create new ones"
          headerRightAdditionalComponent={
            <Button
              mt="20px"
              mr="24px"
              variant="primary"
              px="20px"
              onClick={() => {
                setCurrentView('create/edit');
                setSelectedReport(undefined);
              }}
              data-test-id="reports-schedule-email-button"
            >
              Schedule new email
            </Button>
          }
          // isCtaLoading={isApplying || isFileUploading}
          ctaLabel="Schedule email"
          showFooter={false}
        >
          <>{renderTable()}</>
        </Drawer>
      )}
    </>
  );
};
